import { useState, MouseEvent } from "react";
import { useHistory } from "react-router";
import { useAppSelector } from "../../../context-store";
import { CandidateDashboardModel } from "../../../models/candidate/response/CandidateDashboardModel";
import candidateClasses from "../../../landing-pages/candidate/candidate.module.css";
import CandidateDashboardRatingComponent from "./CandidateDashboardRatingComponent";
import CandidateDashboardInterviewComponent from "./CandidateDashboardInterviewDetails";
import UserPic from "../../../assets/img/content/userPic.png";
import { Alert, Button } from "@mui/material";
import modalUtils from "../../../utils/modal-utils";
import candidateService from "../../../services/candidate/candidate-service";
import fileUtils from "../../../utils/file-utils";
import toasterUtils from "../../../utils/toaster-utils";
import { FileUploadTypeEnum } from "../../../models/enums/FileUploadTypeEnum";

interface CandidateDashboardProps {
    objCandidateDashboardDetails: CandidateDashboardModel;
}

const CandidateDashboardComponent = (props: CandidateDashboardProps) => {
    let loggedInUser = useAppSelector((state) => state.authState.loggedInUser);
    const [candidateDashboardDetails, setCandidateDashboardDetails] = useState<CandidateDashboardModel>(props.objCandidateDashboardDetails);
    const history = useHistory();

    const redirectToSchedule = (event: MouseEvent) => {
        history.push("/schedule-interview");
    };

    const downloadCandidateResume = () => {
        if (loggedInUser) {
            modalUtils.showLoader();
            candidateService.downloadCandidateResume(loggedInUser.profileId, FileUploadTypeEnum.CandidateResume.toString()).then((res) => {
                modalUtils.closeModal();
                fileUtils.downloadFile(res, candidateDashboardDetails.candidateDashboardProfile.resumeTitle);
            }).catch((error) => {
                modalUtils.closeModal();
                toasterUtils.showError(error);
            });
        }
    };

    return (
        <div className="profile-container">
            <div className="row">
                <div className="col-lg-6 col-md-6">
                    <div className="card card-white">
                        <div className="card-head">
                            My Profile
                        </div>
                        <div className="card-body mh250">
                            <div className="row">
                                <div className="col-lg-3 col-md-3">
                                    <div className="userpic-wrapper">
                                        {/* <img src={UserPic} alt="User" className="user-pic"></img> */}
                                        <div className="user-name-wrapper">
                                            <div className="name-letter">
                                                {candidateDashboardDetails.candidateDashboardProfile.candidateName
                                                    ? candidateDashboardDetails.candidateDashboardProfile.candidateName.charAt(0).toUpperCase()
                                                    : ''}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-9 col-md-9 user-info-wrapper">
                                    <h4>{candidateDashboardDetails.candidateDashboardProfile.candidateName}</h4>
                                    <div className="row">
                                        <div className="col-lg-5 col-md-5 user-label">Designation:</div>
                                        <div className="col-lg-7 col-md-7">{candidateDashboardDetails.candidateDashboardProfile.designationName}</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-5 col-md-5 user-label">Primary Skill:</div>
                                        <div className="col-lg-7 col-md-7">{candidateDashboardDetails.candidateDashboardProfile.primarySkillName}</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-5 col-md-5 user-label">Location:</div>
                                        <div className="col-lg-7 col-md-7">{candidateDashboardDetails.candidateDashboardProfile.cityName}</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-5 col-md-5 user-label"> Experience:</div>
                                        <div className="col-lg-7 col-md-7">{candidateDashboardDetails.candidateDashboardProfile.experienceName}</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-5 col-md-5 user-label">My Resume:</div>
                                        <div className="col-lg-7 col-md-7">
                                            <Button variant="outlined" color="primary" startIcon={<i className="fa fa-download"></i>} onClick={downloadCandidateResume} size="small">
                                                Download Resume
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6">
                    <div className="card card-white">
                        <div className="card-head">
                            My Rating
                        </div>
                        <div className="card-body user-info-wrapper mh250">
                            {!candidateDashboardDetails.candidateDashboardActiveInterview &&
                                <Button variant="outlined" color="primary" onClick={redirectToSchedule} size="small">
                                    Please schedule your first interview
                                </Button>
                            }
                            {candidateDashboardDetails.candidateDashboardActiveInterview && !candidateDashboardDetails.candidateDashboardRating &&
                                <Alert severity="info">Your Interview Will be rated soon.</Alert>
                            }
                            {candidateDashboardDetails.candidateDashboardRating && !candidateDashboardDetails.candidateDashboardRating.isCompanyInterview &&
                                <CandidateDashboardRatingComponent
                                    objCandidateDashboardDetails={candidateDashboardDetails.candidateDashboardRating} />
                            }
                            {candidateDashboardDetails.candidateDashboardRating && candidateDashboardDetails.candidateDashboardRating.isCompanyInterview &&
                                <p>This is Company scheduled Interview, rating will not be displayed for this. Please Schedule your own Interview.</p>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-6 col-md-6">
                    <div className="card card-white">
                        <div className="card-head">
                            My Interview Schedule
                        </div>
                        <div className="card-body user-info-wrapper mh-185">
                            {candidateDashboardDetails.candidateDashboardActiveInterview &&
                                <CandidateDashboardInterviewComponent
                                    objCandidateDashboardDetails={candidateDashboardDetails.candidateDashboardActiveInterview} />
                            }
                            {!candidateDashboardDetails.candidateDashboardActiveInterview &&
                                <span>No scheduled Interviews.
                                    <Button variant="outlined" color="primary" onClick={redirectToSchedule} size="small">
                                        Click here to schedule Interview
                                    </Button>
                                </span>
                            }
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6">
                    <div className="card card-white">
                        <div className="card-head">
                            <h6>My Completed Interview</h6>
                        </div>
                        <div className="card-body user-info-wrapper mh-185">
                            {!candidateDashboardDetails.candidateDashboardActiveInterview &&
                                <Button variant="outlined" color="primary" onClick={redirectToSchedule} size="small">
                                    Please schedule your first interview
                                </Button>
                            }
                            {candidateDashboardDetails.candidateDashboardActiveInterview && !candidateDashboardDetails.candidateDashboardCompletedInterview &&
                                <Alert severity="info">Your Interview Will be completed soon.</Alert>
                            }
                            {candidateDashboardDetails.candidateDashboardCompletedInterview &&
                                <CandidateDashboardInterviewComponent
                                    objCandidateDashboardDetails={candidateDashboardDetails.candidateDashboardCompletedInterview} />
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default CandidateDashboardComponent;